import React from 'react';

// ===================================================================
// PHOENIX OS — REDE DE SEGURANÇA CONTRA TELA EM BRANCO
// ===================================================================
// Hoje, se QUALQUER erro acontecer durante a renderização de QUALQUER
// tela (ex: um dossiê antigo com um campo faltando, um cálculo que
// falha com um dado inesperado), o React simplesmente desmonta o app
// inteiro e mostra uma tela em branco — sem nenhuma mensagem, sem
// nenhum jeito de voltar, só um branco confuso pra pessoa.
//
// Esse componente "pega" esses erros antes que eles derrubem o app
// inteiro, mostra uma tela amigável explicando o que aconteceu, e dá
// um botão de "Voltar para o Início" — a pessoa não fica presa.
//
// Isso é uma proteção GERAL, não um conserto do bug específico dos
// dossiês antigos — mas cobre esse caso e qualquer outro parecido no
// futuro, que a gente nem sabe que existe ainda.
// ===================================================================
class ErrorBoundary extends React.Component {
   constructor(props) {
      super(props);
      this.state = { temErro: false };
   }

   static getDerivedStateFromError() {
      return { temErro: true };
   }

   componentDidCatch(erro, info) {
      // Registra no console pra investigarmos depois (e, no futuro,
      // pode mandar isso pra um serviço de monitoramento de erros).
      console.error('[PHOENIX] Erro capturado pela rede de segurança:', erro, info);
   }

   render() {
      if (this.state.temErro) {
         return (
            <div style={{
               minHeight: '100vh', backgroundColor: '#000000', color: '#ffffff',
               display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
               padding: '32px', fontFamily: 'Arial, sans-serif', textAlign: 'center'
            }}>
               <div style={{
                  width: '64px', height: '64px', borderRadius: '50%', backgroundColor: 'rgba(163,230,53,0.1)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px', fontSize: '28px'
               }}>⚠️</div>
               <h1 style={{ fontSize: '20px', fontWeight: '900', textTransform: 'uppercase', marginBottom: '12px', letterSpacing: '-0.5px' }}>
                  Algo deu errado nessa tela
               </h1>
               <p style={{ fontSize: '13px', color: '#94a3b8', maxWidth: '360px', marginBottom: '32px', lineHeight: '1.6' }}>
                  Não conseguimos carregar esse conteúdo — pode ser um registro antigo com algum dado incompleto. Seus outros dados continuam salvos normalmente.
               </p>
               <button
                  onClick={() => window.location.href = '/mobile'}
                  style={{
                     backgroundColor: '#a3e635', color: '#000000', fontWeight: '900', textTransform: 'uppercase',
                     fontSize: '12px', padding: '16px 32px', borderRadius: '9999px', border: 'none', cursor: 'pointer',
                     letterSpacing: '0.05em'
                  }}
               >
                  Voltar para o Início
               </button>
            </div>
         );
      }
      return this.props.children;
   }
}

export default ErrorBoundary;
